import { Link } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { formatFromDateDetails, formatTime } from "../../exports/functions";
import { Fade } from "react-awesome-reveal";
// import { useState } from "react";
// import useTab from "../../hooks/useTab";
import DynamicToolTip from "../DynamicToolTip";

const TopEvents = () => {
  const { eventData } = useEventContext();
  // const tab = useTab();
  // const [activeTab, setActiveTab] = useState<string>("upcoming");
  const activeTab = "upcoming";

  const formatEventDate = (fullDate: string) => new Date(fullDate);

  const today = new Date();

  // Prepare & filter events
  const filteredEvents = eventData
    .map((event) => ({
      ...event,
      attributes: {
        ...event,
        ...formatFromDateDetails(event?.from_date),
        Time: formatTime(event?.start_time),
      },
    }))
    .filter((event) => {
      const eventDate = formatEventDate(event.attributes.From_Full_Date);
      // return activeTab === "upcoming" ? eventDate >= today : eventDate < today;
      return eventDate >= today;
    })
    .slice(0, 5); // Limit to top 4

  return (
    <section className="testimonial-two">
      <div className="container">
        <div className="section-title custom-text-center">
          <span className="custom-fontweight">
            Join Us for Impactful Events
          </span>
          <h2 className="section-title__title">Upcoming Events</h2>
          {/* <div className="quality-work__tab-box tabs-box">
            <ul
              className="tab-buttons clearfix list-unstyled"
              style={{ justifyContent: "center", marginTop: "40px" }}
            >
              <li
                className={`tab-btn ${
                  activeTab === "upcoming" ? "active-btn" : ""
                }`}
                onClick={() => setActiveTab("upcoming")}
                style={{ maxWidth: tab ? "100%" : "380px" }}
              >
                <span>Upcoming</span>
              </li>
              <li
                className={`tab-btn ${
                  activeTab === "past" ? "active-btn" : ""
                }`}
                onClick={() => setActiveTab("past")}
                style={{ maxWidth: tab ? "100%" : "380px" }}
              >
                <span>Past</span>
              </li>
              <li
                className={`tab-btn ${
                  activeTab === "calendar" ? "active-btn" : ""
                }`}
                onClick={() => setActiveTab("calendar")}
                style={{ maxWidth: tab ? "100%" : "380px" }}
              >
                <span>Calendar</span>
              </li>
            </ul>
          </div> */}
        </div>

        <div className="row" style={{ justifyContent: "center" }}>
          {
            // activeTab !== "calendar" ? (
            filteredEvents.length === 0 ? (
              <div className="col-12 text-center">
                <p>{`No ${
                  activeTab.charAt(0).toUpperCase() + activeTab.slice(1)
                } Events`}</p>
              </div>
            ) : (
              filteredEvents.map((event, index) => (
                <div className="col-5th custom-margin-bottom" key={index}>
                  <Fade
                    cascade
                    damping={0.2}
                    triggerOnce={true}
                    delay={index * 200}
                  >
                    <Link
                      to={`/events/events-details/${index}?tab=${activeTab}`}
                    >
                      <div className="events__single">
                        <div className="events__img">
                          <img
                            src={
                              event?.image[0]?.media?.url &&
                              `${process.env.REACT_APP_cmsUrl}${event?.image[0]?.media?.url}`
                            }
                            alt="event-image"
                            className="row-image"
                            style={{ objectFit: "cover" }}
                          />
                          <div className="events__date">
                            <p>
                              {event?.attributes?.From_Date} <br />
                              {event?.attributes?.From_Month} <br />
                              {event?.attributes?.From_Year}
                            </p>
                          </div>
                        </div>
                        <div
                          className="events__content row-content"
                          style={{ backgroundColor: "#ffffff" }}
                        >
                          <h3
                            className="events__title custom-grid-font-size text-truncate"
                            style={{ marginBottom: "unset" }}
                          >
                            <DynamicToolTip title={event?.event_name}>
                              {event?.event_name}
                            </DynamicToolTip>
                          </h3>
                          <ul className="list-unstyled events__meta">
                            <li
                              className="d-flex align-items-center"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <i className="far fa-clock"></i>
                              {
                                <DynamicToolTip title={event?.attributes?.Time}>
                                  {event?.attributes?.Time}
                                </DynamicToolTip>
                              }
                            </li>
                            <li className="text-truncate">
                              <i className="fas fa-map-marker-alt"></i>
                              {
                                <DynamicToolTip
                                  title={
                                    event?.event_location === " "
                                      ? "N/A"
                                      : event?.event_location
                                  }
                                >
                                  {event?.event_location === " "
                                    ? "N/A"
                                    : event?.event_location}
                                </DynamicToolTip>
                              }
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Link>
                  </Fade>
                </div>
              ))
            )
            // ) : (
            //   <div className="col-xl-12">
            //     <iframe
            //       title="FRC Google Calendar"
            //       src="https://calendar.google.com/calendar/embed?src=bdf60c3eb90c74c76af2a8957b06ac167d8f5e8938ae717662c4c42eeaf38bdd%40group.calendar.google.com&ctz=Asia%2FKathmandu"
            //       style={{ border: "0" }}
            //       width="100%"
            //       height="600"
            //       scrolling="no"
            //     ></iframe>
            //   </div>
            // )
          }
        </div>
      </div>
    </section>
  );
};

export default TopEvents;
